export default __webpack_public_path__ + "static/media/trout_thumb.d56d0528.jpg";